export default {
  opportunityList: null,
  seeMore: false
}
